import { Capacitor } from "@capacitor/core";
import { readMobileToken } from "./native/secure-store";

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export const MOBILE_API_ORIGIN = "https://mblive.mokshabase.com";

export function isMobileApp(): boolean {
  return Capacitor.isNativePlatform();
}

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  headers.set("X-MB-Client", "mblive");
  if (init.body && !(init.body instanceof FormData) && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  if (isMobileApp()) {
    const token = await readMobileToken();
    if (token) headers.set("Authorization", `Bearer ${token}`);
  }
  const target = isMobileApp() && path.startsWith("/") ? `${MOBILE_API_ORIGIN}${path}` : path;
  return fetch(target, { ...init, headers, credentials: isMobileApp() ? "omit" : "include" });
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await apiFetch(path, init);
  if (response.status === 204) return undefined as T;
  const contentType = response.headers.get("content-type") ?? "";
  if (!contentType.includes("json")) {
    if (!response.ok) throw new ApiError(response.status, "Request failed");
    return undefined as T;
  }
  const body = await response.json() as { success: boolean; data: T; error: string | null };
  if (response.status === 401 && !/\/auth\/(session|login|mobile-login|demo)$/.test(path)) {
    window.dispatchEvent(new CustomEvent("mb-unauthorized"));
  }
  if (!response.ok || !body.success) throw new ApiError(response.status, body.error ?? "Request failed");
  return body.data;
}

export function money(cents: number): string {
  return new Intl.NumberFormat("en-NZ", { style: "currency", currency: "NZD" }).format(cents / 100);
}
